import { render } from "./StepAssocia.vue?vue&type=template&id=a1e44d64&scoped=true"
import script from "./StepAssocia.vue?vue&type=script&lang=js"
export * from "./StepAssocia.vue?vue&type=script&lang=js"

import "./StepAssocia.vue?vue&type=style&index=0&id=a1e44d64&scoped=true&lang=css"
import "./StepAssocia.vue?vue&type=style&index=1&id=a1e44d64&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e44d64"]])

export default __exports__